import {
  getCards,
  getPassport,
  restartPassport,
  setActiveCard,
} from "@/api/gameApi"
import { StarterCardChoice } from "@/constants/starterCards"
import { CardElement, DigitalPassport, GameCard } from "@/types/battle"

export async function equipFirstStarterCard(
  passport: DigitalPassport,
  cards: GameCard[]
): Promise<{ passport: DigitalPassport; needsPickActive: boolean }> {
  const needsActive =
    !passport.activeCardId?.trim() && !passport.activeCard?.id?.trim()
  const firstId = cards[0]?.id?.trim()
  if (!needsActive || !firstId) {
    return { passport, needsPickActive: false }
  }
  try {
    const updated = await setActiveCard(firstId)
    return { passport: updated, needsPickActive: false }
  } catch {
    return { passport, needsPickActive: true }
  }
}

export type RecoverGuardiansResult =
  | { status: "tabs"; passport: DigitalPassport; cards: GameCard[] }
  | { status: "active"; passport: DigitalPassport; cards: GameCard[] }
  | { status: "need_cards"; passport: DigitalPassport }
  | { status: "no_passport" }
  | { status: "no_cards" }

/**
 * Вход в игру, когда паспорт уже есть на бэке (повторный select-league и т.п.).
 * Если карт 0 и переданы starterCards — POST restart.
 * Одна карта (после продаж) — валидный вход в tabs, не онбординг.
 */
export async function recoverGuardiansEntry(
  starterCards?: [StarterCardChoice, StarterCardChoice] | null,
  affiliationElement?: CardElement | null,
  guardianPath?: import("@/types/battle").GuardianPath | null
): Promise<RecoverGuardiansResult> {
  let passport = await getPassport()
  if (!passport) {
    return { status: "no_passport" }
  }

  let cards = await getCards()

  if (
    cards.length === 0 &&
    starterCards &&
    affiliationElement &&
    guardianPath
  ) {
    const restarted = await restartPassport({
      starterCards,
      affiliationElement,
      guardianPath,
    })
    passport = restarted.passport
    cards = restarted.cards
  }

  if (cards.length === 0) {
    if (passport) {
      return { status: "need_cards", passport }
    }
    return { status: "no_cards" }
  }

  const equipped = await equipFirstStarterCard(passport, cards)
  if (equipped.needsPickActive) {
    return { status: "active", passport: equipped.passport, cards }
  }

  return { status: "tabs", passport: equipped.passport, cards }
}
